import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" {...props}><circle cx="19.416" cy="21.07" r="14.93" opacity=".5" /><path d="M17.337 23.222h-5.743v-4.209h5.743V13.25h4.154v5.763h5.744v4.209H21.49v5.669h-4.154v-5.67z" /></svg>;